<template>
 
    <div>
          <!-- 第三行数据 -->
            <topLeft style="width: 49%;height: 45vh;float: left;margin-left: 0.5%;"></topLeft>
            <topRight  style="width: 49%;height: 45vh;float: left;margin-left: 1%;"/>
           <bottomLeft style="width: 49%;height: 45vh;float: left;margin-top: 1vh;margin-left: 0.5%;" />

            <bottomRight  style="width: 49%;height: 45vh;float: left;margin-top: 1vh;;margin-left: 1%;"/>
            

          
    </div>
</template>

<script>
import topLeft from "./show2/topLeft";
 import topRight from "./show2/topRight";

 import bottomLeft from "./show2/bottomLeft";

 import bottomRight from "./show2/bottomRight";

export default {
  data() {
    return {
      loading: true,
    };
  },
  components: {
    topLeft,
    topRight,
    bottomLeft,
    bottomRight
    
  },
  mounted() {
    this.cancelLoading();
  },
  methods: {
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/bigScreen/scss/index.scss";
</style>